export const FETCH_SCORES = 'FETCH_SCORES';
